module.exports = __webpack_public_path__ + "static/media/discount-codes-default.ef9a4206.svg";